"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "trackUserEvent", {
  enumerable: true,
  get: function get() {
    return _trackUserEvent["default"];
  }
});
var _trackUserEvent = _interopRequireDefault(require("./trackUserEvent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }